import SyosUiContainer from './SyosUiContainer';
import SyosPageComponent from './components/SyosPageComponent';
import SyosEvents from './utils/SyosEvents';
import { LEGEND_ID } from './SyosLegend';
import type SyosController from './SyosController';
import type SyosMediaQuery from './utils/SyosMediaQuery';

const Class = {
  BTN_SHOW_LEGEND: 'tn-syos-legend__btn-show-legend',
};

function getHtml() {
  const { legendLabel } = SyosPageComponent;

  return `
  <button type="button" class="btn btn-default ${Class.BTN_SHOW_LEGEND}" aria-expanded="false" aria-controls="${LEGEND_ID}">
    ${legendLabel}
    </button>
  `;
}

class SyosBtnToggleLegend extends SyosUiContainer {
  $btn: JQuery<HTMLElement>;

  isExpanded = false;

  syosMediaQuery: SyosMediaQuery;

  constructor(syosController: SyosController, syosMediaQuery: SyosMediaQuery) {
    super(syosController, '.tn-syos-btn-toggle-legend__container');

    this.syosMediaQuery = syosMediaQuery;

    this.$el.html(getHtml());

    this.$btn = this.find(`.${Class.BTN_SHOW_LEGEND}`);
    this.$btn.on('click', this.onClick);

    this.syosController.on(SyosEvents.LEGEND_DETAILS_HIDE, () => this.setAriaExpanded(false));
    this.syosController.on(SyosEvents.LEGEND_DETAILS_SHOW, () => this.setAriaExpanded(true));

    syosMediaQuery.on(SyosEvents.TABLET_ENTER, this.onTabletEnter);
    syosMediaQuery.on(SyosEvents.TABLET_LEAVE, this.onTabletLeave);
  }

  onClick = () => {
    this.syosController.emit(SyosEvents.LEGEND_DETAILS_TOGGLE);
  };

  onTabletEnter = () => {
    this.$btn.removeAttr('aria-expanded');
  };

  onTabletLeave = () => {
    this.setAriaExpanded(this.isExpanded);
  };

  setAriaExpanded = (isExpanded: boolean) => {
    this.isExpanded = isExpanded;

    this.$btn.attr('aria-expanded', isExpanded ? 'true' : 'false');
  };

  destroy() {
    this.syosMediaQuery?.removeListener(SyosEvents.TABLET_ENTER, this.onTabletEnter);
    this.syosMediaQuery?.removeListener(SyosEvents.TABLET_LEAVE, this.onTabletLeave);

    this.syosMediaQuery = undefined;

    this.$btn.off('click', this.onClick);

    super.destroy();
  }
}

export default SyosBtnToggleLegend;
